<dx-form
  id="columnForm"
  labelMode="floating"
  [formData]="columnFormData"
  [colCount]="1"
  [colCountByScreen]="{ xs: 1 }"
>
  <dxi-item dataField="valueTo" [editorOptions]="{ stylingMode: 'underlined' }">
    <dxi-validation-rule
      type="required"
      [message]="formatMessage('validation.required')"
    ></dxi-validation-rule>
    <dxi-validation-rule
      type="pattern"
      [pattern]="numberPattern"
      [message]="formatMessage('validation.numericOnly')"
    >
    </dxi-validation-rule>
    <dxi-validation-rule
      type="custom"
      [validationCallback]="checkFormValueUnique"
      [message]="formatMessage('validation.unique')"
    >
    </dxi-validation-rule>
  </dxi-item>
</dx-form>
